import { t } from '../../utilities/translator';
// import ReactTooltip from '@huner2/react-tooltip';
// import { WithTooltip } from '../../components/tooltip/WithTooltip';

const GroupModalStep1 = ({ nextClick }) => {
  return (
    <>
      <div className="flex flex-col gap-6 pb-8 gbm-main">
        <h3 className="gb-title">{t('groupBookingTutorial.modalStep1Title')}</h3>
        <div className="gb-badge flex items-center justify-center">
          <div className="gbb-icons flex items-center">
            <div className="gbb-icon flex items-center justify-center">
              <span className="gbb-group-1-icon" />
              <i className="ri-checkbox-circle-fill" />
            </div>
            <div className="gbb-icon flex items-center justify-center">
              <span className="gbb-group-2-icon" />
              <i className="ri-checkbox-circle-fill" />
            </div>
            <div className="gbb-icon flex items-center justify-center">
              <span className="gbb-group-1-icon" />
              <i className="ri-checkbox-circle-fill" />
            </div>
          </div>
        </div>
        <div className="gb-step-txt">
          {t('groupBookingTutorial.modalStep1Text')}
        </div>
        {/* <div className="flex">
          <WithTooltip text={`<div class="price-tooltip"><span>${t('groupBookingTutorial.splitPaymentTooltipTxt')}</span></div>`}>
            <div className="gb-step-bot flex items-center gap-1 cursor-pointer">
              <i className="ri-information-line" />
              <span>{t('groupBookingTutorial.onlyLookingToSplit')}</span>
            </div>
          </WithTooltip>
        </div>
        <ReactTooltip effect="solid" className="tooltip-container" /> */}
      </div>
      <div className="flex gap-4 mt-auto justify-between gbm-foot">
        <button className="move-btn move-btn--large rounded invisible" disabled>{t('groupBookingTutorial.back')}</button>
        <div className="flex items-center gap-1 gbmf-dots">
          <span className="active" />
          <span />
        </div>
        <button className="move-btn move-btn--primary move-btn--large rounded" onClick={nextClick}>{t('groupBookingTutorial.next')}<i className="ri-arrow-right-line" /></button>
      </div>
    </>
  );
};

export default GroupModalStep1;
